exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3apYv9RjksxbKoa12chVMK{display:flex;font-size:14px;background:#ebebeb}._1YzVYx3H6cZrW00ZkPfK-c{flex:1;text-align:center;cursor:pointer;padding:10px 15px;border-right:1px solid #bbb;border-bottom:1px solid #bbb}._1YzVYx3H6cZrW00ZkPfK-c:last-child{border-right:none}._3GEseyXJRCySPU_HhIJtxq{font-weight:bold;background:#f7f7f7;border-bottom:3px solid #f70}\n", ""]);

// Exports
exports.locals = {
	"TabNav": "_3apYv9RjksxbKoa12chVMK",
	"Tab": "_1YzVYx3H6cZrW00ZkPfK-c",
	"activeTab": "_3GEseyXJRCySPU_HhIJtxq"
};